webpackJsonp([264598414423048],{

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = exports.AboutPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(39);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _NavBar = __webpack_require__(14);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPageTemplate = exports.AboutPageTemplate = function AboutPageTemplate(_ref) {
	    var title = _ref.title,
	        content = _ref.content,
	        contentComponent = _ref.contentComponent;
	
	    var PageContent = contentComponent || _Content2.default;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_NavBar2.default, null),
	        _react2.default.createElement(
	            'section',
	            { className: 'hero is-primary is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'column is-10 is-offset-1' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'section' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'title' },
	                                    title
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section section--gradient' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-10 is-offset-1' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section' },
	                            _react2.default.createElement(PageContent, { className: 'content', content: content })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}; /**
	    * Created by vaibhav on 31/3/18
	    */
	
	
	AboutPageTemplate.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    content: _propTypes2.default.string,
	    contentComponent: _propTypes2.default.func
	};
	
	var AboutPage = function AboutPage(_ref2) {
	    var data = _ref2.data;
	    var post = data.markdownRemark;
	
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                post.frontmatter.meta_title
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: post.frontmatter.meta_description })
	        ),
	        _react2.default.createElement(AboutPageTemplate, {
	            contentComponent: _Content.HTMLContent,
	            title: post.frontmatter.title,
	            content: post.html
	        })
	    );
	};
	
	AboutPage.propTypes = {
	    data: _propTypes2.default.object.isRequired
	};
	
	exports.default = AboutPage;
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-page-js-0d2188294b3801223eb5.js